var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingCoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219,
    height: 219,
    viewBox: "0 0 219 219",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 131.153C102.719 132.057 101.979 132.92 101.003 133.742C100.037 134.499 98.9479 135.17 97.7345 135.753C96.5998 136.283 95.4196 136.674 94.1941 136.924C92.9686 137.175 91.8832 137.218 90.9379 137.055L44.0415 128.951C43.0961 128.788 42.2571 128.412 41.5244 127.823C40.7916 127.234 40.2161 126.54 39.7978 125.742C39.4581 124.89 39.2983 124.004 39.3184 123.083C39.3495 122.098 39.617 121.153 40.1209 120.25L48.3512 105.821L62.9366 108.342L57.4271 117.891L91.3586 123.754L96.8681 114.205L111.454 116.725L103.223 131.153ZM121.328 98.8166C121.205 99.1255 121.122 99.4083 121.078 99.6648C121.033 99.9213 120.921 100.166 120.742 100.399L119.129 103.093L56.0267 92.1889L57.6395 89.4956C57.8189 89.2624 57.9645 89.0234 58.0764 88.7786C58.2557 88.5454 58.4744 88.286 58.7324 88.0004L121.328 98.8166ZM116.821 91.6976C118.037 91.9076 119.056 92.447 119.88 93.3158C120.703 94.1846 121.223 95.199 121.44 96.3592L61.1737 85.9456C62.5775 85.0654 64.0832 84.401 65.6906 83.9522C67.2981 83.5035 68.7095 83.3842 69.925 83.5942L116.821 91.6976ZM103.436 102.758L69.5043 96.8953L66.9845 101.215L52.399 98.6947L55.1032 93.9115L118.206 104.815L115.501 109.598L100.916 107.078L103.436 102.758ZM48.6701 105.183L51.6765 99.8577L66.3633 102.396L63.2556 107.703L48.6701 105.183ZM97.1871 113.567L100.295 108.259L114.779 110.761L111.773 116.087L97.1871 113.567Z",
    fill: "#FF86EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76 143.169C172.256 144.073 171.516 144.935 170.539 145.757C169.574 146.515 168.485 147.185 167.271 147.768C166.136 148.299 164.956 148.689 163.731 148.94C162.505 149.19 161.42 149.234 160.474 149.07L113.578 140.967C112.633 140.804 111.794 140.427 111.061 139.839C110.328 139.25 109.753 138.556 109.334 137.757C108.995 136.906 108.835 136.02 108.855 135.099C108.886 134.113 109.154 133.169 109.657 132.265L117.888 117.837L132.473 120.357L126.964 129.906L160.895 135.769L166.405 126.22L180.99 128.741L172.76 143.169ZM190.865 110.832C190.742 111.141 190.658 111.424 190.614 111.68C190.57 111.937 190.458 112.182 190.279 112.415L188.666 115.108L125.563 104.204L127.176 101.511C127.355 101.278 127.501 101.039 127.613 100.794C127.792 100.561 128.011 100.301 128.269 100.016L190.865 110.832ZM186.358 103.713C187.573 103.923 188.593 104.463 189.416 105.331C190.24 106.2 190.76 107.215 190.977 108.375L130.71 97.9611C132.114 97.0809 133.62 96.4165 135.227 95.9677C136.835 95.519 138.246 95.3997 139.462 95.6097L186.358 103.713ZM172.972 114.774L139.041 108.911L136.521 113.231L121.936 110.71L124.64 105.927L187.742 116.831L185.038 121.614L170.453 119.094L172.972 114.774ZM118.207 117.199L121.213 111.873L135.9 114.411L132.792 119.719L118.207 117.199ZM166.724 125.582L169.831 120.274L184.316 122.777L181.309 128.102L166.724 125.582Z",
    fill: "#FF86EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.312 77.1025L163.812 82.027L160.012 88.489L131.513 83.5645L135.312 77.1025Z",
    fill: "#FF86EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1871 65.1611L94.6867 70.0856L90.8867 76.5476L62.3877 71.6231L66.1871 65.1611Z",
    fill: "#FF86EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.869 106.382L191.584 105.469L190.664 110.79L195.95 111.704L196.869 106.382Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.236 112.618L195.95 111.704L195.031 117.026L200.317 117.94L201.236 112.618Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.317 117.94L195.031 117.026L194.111 122.349L199.397 123.262L200.317 117.94Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.031 117.026L189.744 116.114L188.825 121.436L194.111 122.349L195.031 117.026Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.121 122.288L188.835 121.374L187.916 126.696L193.201 127.609L194.121 122.288Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 126.696L182.629 125.783L181.71 131.105L186.995 132.018L187.916 126.696Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.744 116.114L184.458 115.2L183.538 120.522L188.825 121.436L189.744 116.114Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.835 121.374L183.549 120.461L182.629 125.783L187.916 126.696L188.835 121.374Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.629 125.783L177.345 124.87L176.426 130.192L181.71 131.105L182.629 125.783Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.71 131.105L176.426 130.192L175.506 135.512L180.792 136.425L181.71 131.105Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.426 130.192L171.142 129.277L170.223 134.599L175.506 135.512L176.426 130.192Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.142 129.277L165.856 128.364L164.936 133.685L170.223 134.599L171.142 129.277Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.506 135.512L170.223 134.599L169.303 139.922L174.588 140.835L175.506 135.512Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.793 123.64L101.508 122.726L100.588 128.048L105.874 128.961L106.793 123.64Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.219 134.599L164.933 133.686L164.014 139.008L169.299 139.921L170.219 134.599Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.508 122.726L96.2239 121.813L95.3043 127.135L100.588 128.048L101.508 122.726Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1426 116.491L91.857 115.577L90.9375 120.899L96.2239 121.813L97.1426 116.491Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0619 111.171L92.7763 110.257L91.857 115.577L97.1426 116.491L98.0619 111.171Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9816 105.848L93.696 104.935L92.7763 110.257L98.0619 111.171L98.9816 105.848Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.265 106.761L98.9816 105.848L98.0619 111.171L103.346 112.083L104.265 106.761Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.933 133.686L159.649 132.773L158.73 138.095L164.014 139.008L164.933 133.686Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2239 121.813L90.9375 120.899L90.0178 126.222L95.3043 127.135L96.2239 121.813Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.857 115.577L86.5732 114.664L85.6536 119.986L90.9375 120.899L91.857 115.577Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7763 110.257L87.4924 109.344L86.5732 114.664L91.857 115.577L92.7763 110.257Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.696 104.935L88.4121 104.022L87.4924 109.344L92.7763 110.257L93.696 104.935Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M165.856 128.364L160.569 127.45L159.649 132.773L164.933 133.686L165.856 128.364Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.764 123.101L161.478 122.187L160.559 127.509L165.844 128.422L166.764 123.101Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.683 117.781L162.398 116.867L161.478 122.187L166.764 123.101L167.683 117.781Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.967 118.694L167.683 117.781L166.764 123.101L172.048 124.015L172.967 118.694Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M157.113 115.954L151.827 115.041L150.908 120.363L156.193 121.276L157.113 115.954Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M156.203 121.217L150.918 120.304L149.998 125.626L155.284 126.539L156.203 121.217Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M155.284 126.539L149.998 125.626L149.079 130.945L154.365 131.859L155.284 126.539Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M159.649 132.773L154.365 131.859L153.446 137.182L158.73 138.095L159.649 132.773Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9375 120.899L85.6536 119.986L84.7339 125.309L90.0178 126.222L90.9375 120.899Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5732 114.664L81.2866 113.751L80.367 119.072L85.6536 119.986L86.5732 114.664Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4924 109.344L82.2058 108.431L81.2866 113.751L86.5732 114.664L87.4924 109.344Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2058 108.431L76.9193 107.517L75.9997 112.839L81.2866 113.751L82.2058 108.431Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4121 104.022L83.1256 103.108L82.2058 108.431L87.4924 109.344L88.4121 104.022Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1256 103.108L77.839 102.195L76.9193 107.517L82.2058 108.431L83.1256 103.108Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.839 102.195L72.5551 101.282L71.6356 106.603L76.9193 107.517L77.839 102.195Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M160.569 127.45L155.284 126.539L154.365 131.859L159.649 132.773L160.569 127.45Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M161.478 122.187L156.193 121.276L155.275 126.596L160.559 127.509L161.478 122.187Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.398 116.867L157.113 115.954L156.193 121.276L161.478 122.187L162.398 116.867Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M151.827 115.041L146.541 114.127L145.621 119.449L150.908 120.363L151.827 115.041Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M125.399 110.474L120.113 109.561L119.194 114.883L124.479 115.796L125.399 110.474Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M119.205 114.824L113.92 113.911L113 119.233L118.286 120.146L119.205 114.824Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M113 119.233L107.714 118.317L106.793 123.64L112.08 124.552L113 119.233Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.541 114.127L141.254 113.214L140.335 118.536L145.621 119.449L146.541 114.127Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M120.113 109.561L114.829 108.648L113.91 113.969L119.194 114.883L120.113 109.561Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M113.92 113.911L108.633 112.997L107.714 118.317L113 119.233L113.92 113.911Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M109.542 107.734L104.256 106.821L103.337 112.143L108.622 113.056L109.542 107.734Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.429 117.404L97.1426 116.491L96.2239 121.813L101.508 122.726L102.429 117.404Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M107.714 118.317L102.429 117.404L101.508 122.726L106.793 123.64L107.714 118.317Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M150.918 120.304L145.631 119.39L144.712 124.712L149.998 125.626L150.918 120.304Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M178.256 119.608L172.971 118.694L172.051 124.016L177.337 124.929L178.256 119.608Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M184.458 115.2L179.174 114.287L178.256 119.608L183.538 120.522L184.458 115.2Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M179.174 114.287L173.89 113.374L172.971 118.694L178.256 119.608L179.174 114.287Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.886 113.374L168.601 112.46L167.683 117.781L172.967 118.694L173.886 113.374Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.601 112.46L163.317 111.547L162.398 116.867L167.683 117.781L168.601 112.46Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M163.317 111.547L158.033 110.634L157.113 115.954L162.398 116.867L163.317 111.547Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M158.033 110.634L152.746 109.721L151.827 115.041L157.113 115.954L158.033 110.634Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M152.746 109.721L147.46 108.807L146.541 114.127L151.827 115.041L152.746 109.721Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M147.46 108.807L142.173 107.894L141.254 113.214L146.541 114.127L147.46 108.807Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M142.173 107.894L136.889 106.981L135.97 112.303L141.254 113.214L142.173 107.894Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M136.889 106.981L131.606 106.068L130.686 111.39L135.97 112.303L136.889 106.981Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M131.602 106.067L126.316 105.154L125.399 110.474L130.682 111.389L131.602 106.067Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M126.316 105.154L121.032 104.241L120.113 109.561L125.399 110.474L126.316 105.154Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.032 104.241L115.749 103.328L114.829 108.648L120.113 109.561L121.032 104.241Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M115.749 103.328L110.462 102.414L109.542 107.734L114.829 108.648L115.749 103.328Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M110.462 102.414L105.175 101.501L104.256 106.821L109.542 107.734L110.462 102.414Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.175 101.501L99.8915 100.588L98.972 105.91L104.256 106.821L105.175 101.501Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8915 100.588L94.605 99.6744L93.6854 104.996L98.972 105.91L99.8915 100.588Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.605 99.6744L89.3211 98.7614L88.4015 104.083L93.6854 104.996L94.605 99.6744Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3211 98.7614L84.0345 97.8479L83.115 103.17L88.4015 104.083L89.3211 98.7614Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0345 97.8479L78.7479 96.9344L77.8284 102.256L83.115 103.17L84.0345 97.8479Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7479 96.9344L73.4641 96.0214L72.5445 101.343L77.8284 102.256L78.7479 96.9344Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4641 96.0214L68.1775 95.1079L67.2579 100.43L72.5445 101.343L73.4641 96.0214Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0962 89.7851L63.8106 88.8717L62.8911 94.1934L68.1775 95.1079L69.0962 89.7851Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7321 83.5494L59.4465 82.6361L58.5269 87.9577L63.8106 88.8717L64.7321 83.5494Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3652 77.3133L55.0796 76.4L54.1601 81.7216L59.4465 82.6361L60.3652 77.3133Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M192.503 100.146L187.217 99.2325L186.297 104.554L191.584 105.469L192.503 100.146Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9984 71.0772L50.7128 70.1638L49.7932 75.4855L55.0796 76.4L55.9984 71.0772Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M188.136 93.9097L182.85 92.9964L181.931 98.318L187.217 99.2325L188.136 93.9097Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6315 64.841L46.3459 63.9277L45.4264 69.2494L50.7128 70.1638L51.6315 64.841Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 87.6735L178.483 86.7602L177.564 92.0819L182.85 92.9964L183.769 87.6735Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2647 58.6049L41.9791 57.6916L41.0595 63.0132L46.3459 63.9277L47.2647 58.6049Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M179.402 81.4374L174.116 80.5241L173.197 85.8458L178.483 86.7602L179.402 81.4374Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M42.897 52.3718L37.6114 51.4585L36.6918 56.7801L41.9791 57.6916L42.897 52.3718Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M175.034 75.2031L169.748 74.2898L168.829 79.6114L174.116 80.5241L175.034 75.2031Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6114 51.4585L32.3249 50.5436L31.4053 55.8653L36.6918 56.7801L37.6114 51.4585Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3249 50.5436L27.0382 49.6301L26.1186 54.9517L31.4053 55.8653L32.3249 50.5436Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M170.666 68.9718L165.381 68.0585L164.461 73.3801L169.747 74.2934L170.666 68.9718Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M165.381 68.0585L160.094 67.1449L159.174 72.4666L164.461 73.3801L165.381 68.0585Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M160.094 67.1449L154.808 66.2316L153.889 71.5533L159.174 72.4666L160.094 67.1449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingCoolIcon);
export default __webpack_public_path__ + "static/media/SomethingCoolIcon.15dd47f4c426933aafaf299374904c32.svg";
export { ForwardRef as ReactComponent };